module.exports = __webpack_public_path__ + "static/media/icon_arrow_left.cc558170.svg";